<template>
    <b-list-group class="mt-2">
        <b-list-group-item
            variant="secondary"
        >
            <font-awesome-icon
                icon="file-alt"
                class="mr-2"
            ></font-awesome-icon>
            Forms
        </b-list-group-item>
        <b-list-group-item
            v-for="(semesterForm, idx) in semesterForms"
            :key="idx"
            :to="{ name: 'form2', params: { id: semesterForm.form.id }, query: { submit_redirect: '/register' } }"
        >
            <b-check
                :checked="semesterForm.submitted"
                :disabled="semesterForm.submitted"
                class="mr-2"
            >
                <router-link
                    :to="{ name: 'form2', params: { id: semesterForm.form.id }, query: { submit_redirect: '/register' } }"
                >
                    <div :class="{ textStrike: semesterForm.submitted }">
                        {{ semesterForm.form.title }}
                    </div>
                </router-link>
            </b-check>
        </b-list-group-item>
        <b-list-group-item
            v-if="loadingSemesterForms"
            class="text-center"
        >
            <b-spinner variant="primary"></b-spinner>
        </b-list-group-item>
        <b-list-group-item
            v-if="semester.require_membership_form"
            :to="{ name: 'membership' }"
        >
            <b-check
                v-if="!loadingFormStatus"
                :checked="membershipFormSubmitted"
                :disabled="true"
                class="cursor-pointer mr-2"
            >
                <router-link
                    :to="{ name: 'membership' }"
                >
                    <div :class="{ textStrike: membershipFormSubmitted }">
                        Membership and Renewal Form &mdash; {{ semester.label }}
                    </div>
                </router-link>
            </b-check>                
        </b-list-group-item>
    </b-list-group>
</template>
<script>
export default {
    props: ["semester"],
    data() {
        return {
            loadingFormStatus: false,
            loadingSemesterForms: false,
            membershipFormSubmitted: false,
            semesterForms: []
        }
    },
    mounted() {
        this.getFormStatus();
        this.getSemesterForms();
    },
    methods: {
        getFormStatus() {
            this.loadingFormStatus = true;
            this.$api.get("/api/membership/prefill").then((response) => {
                const data = response.data;
                this.membershipFormSubmitted = false;
                if (typeof data.prefillData.id == "number") {
                    this.membershipFormSubmitted = !data.prefillData.expired;
                }
                this.loadingFormStatus   = false;

                // Set reason for being allowed to continue or not.
                if (this.semester.require_membership_form && !this.membershipFormSubmitted) {
                    this.$emit("input", `Requires Membership Renewal Form — ${this.semester.label}`);
                }
            });
        },
        getSemesterForms() {
            this.loadingSemesterForms = true;
            this.$api.get(
                "/api/forms/fetch-semester-forms"
            ).then(({ data }) => {
                this.semesterForms        = data.forms;
                this.loadingSemesterForms = false;

                // Set reason for being allowed to continue or not.
                if (this.semesterForms) {
                    for (var form of this.semesterForms) {
                        if (!form.submitted && form.required) {
                            this.$emit("input", `Requires "${form.form.title}"`);
                        }
                    }
                }
            });
        }
    }
}
</script>